import React from 'react';

import FaCheck from 'react-icons/lib/fa/check';
import FaRefresh from 'react-icons/lib/fa/refresh';

import LoadingDots from '../LoadingDots/LoadingDots';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './Button.scss';

function loadingPropCheck(props, propName, componentName) {
    if (typeof props[propName] !== 'boolean' && props[propName] !== undefined) {
        return new Error(
            'Invalid prop `' + propName + '` supplied to'
                + ' `' + componentName + '`. Must be a boolean.',
        );
    }
    if (props.success && props[propName]) {
        return new Error(
            'Invalid prop `' + propName + '` supplied to'
                + ' `' + componentName + '`. Success and loading cannot both be true.',
        );
    }

    return undefined;
}

function renderChild(props) {
    const {
        children,
        loading,
        loadingAnimation = 'spin',
        success,
    } = props;

    if (loading) {
        return loadingAnimation === 'spin'
            ? <FaRefresh className={styles.spinner} />
            : <LoadingDots className={styles.loadingDots} />;
    }

    if (success) {
        return (
            <span className={styles.checkContainer}>
                {children} <FaCheck className={styles.check} />
            </span>
        );
    }

    return children;
}

export {
    loadingPropCheck,
    renderChild,
};
